import Vue from 'vue';
import Cookie from 'js-cookie';
import VueAnalytics from 'vue-analytics';
import SocialSharing from 'vue-social-sharing';
// Vue resource
import VueResource from 'vue-resource';
import App from './App';
// Routes
import router from './router';
// Vuex
import store from './store';

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-47869128-6',
  router,
});

Vue.use(VueResource);

Vue.http.options.emulateHTTP = true;
Vue.http.options.emulateJSON = true;
Vue.http.options.root = 'http://leobrossault.fr/mystere-de-pekin/data';

Vue.use(SocialSharing);

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);

  if (to.path === '/choisir-son-personnage-slide' || to.path === '/valider-son-personnage') {
    if (!store.getters.getCharactersData) {
      next('/');
    }
  }

  if (to.path === '/jeu' && !Cookie.get('question') && !Cookie.get('player')) {
    next('/');
  }

  if (to.path === '/the-end' && !Cookie.get('question') && !Cookie.get('player')) {
    next('/');
  }

  next();
});

new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js